export enum AppId {
  HPScoutSO = 'hpscoutso',
  Lut = 'lut',
}
